/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* GCP project configuration. Applicable if `cloudProvider` is set to `GCP`. 
*/
export class GcpAccountConfigInput {
  'serviceAccount': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "serviceAccount",
      "baseName": "serviceAccount",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GcpAccountConfigInput.attributeTypeMap;
  }

  public constructor() {
  }
}

